import sendOwsAttachmentRequest from './httpRequestHelpers/sendOwsAttachmentRequest';
import prependServiceBaseUrl from '../utils/prependServiceBaseUrl';
import type AttachmentType from 'owa-service/lib/contract/AttachmentType';
import type { ClientItemId } from 'owa-client-ids';
import createReferenceAttachmentFromLocalFileRequest from 'owa-service/lib/factory/createReferenceAttachmentFromLocalFileRequest';

const CREATE_ATTACHMENT_URL = prependServiceBaseUrl(
    '/service.svc/CreateReferenceAttachmentFromLocalFile'
);

export default async function createReferenceAttachmentFromLocalFile(
    parentItemId: ClientItemId,
    attachment: AttachmentType,
    cancellationId: string,
    backingObject: Blob,
    subscriptionId: string,
    channelId: string,
    sliceNumber: number,
    totalSlices: number,
    groupId: string,
    folderId: string
): Promise<string> {
    const requestData = createReferenceAttachmentFromLocalFileRequest({
        ParentItemId: parentItemId,
        FileName: attachment.Name,
        SubscriptionId: subscriptionId,
        ChannelId: channelId,
        FileSizeInBytes: attachment.Size,
        SliceNumber: sliceNumber,
        TotalSlices: totalSlices,
        CancellationId: cancellationId,
        FileContentToUpload: '',
        GroupSmtpAddress: groupId,
        UploadFolderId: folderId,
    });

    const jsonRequest = {
        requestObject: requestData,
    };

    const jsonResponse = await sendOwsAttachmentRequest(
        CREATE_ATTACHMENT_URL,
        jsonRequest,
        'CreateReferenceAttachmentFromLocalFile',
        parentItemId.mailboxInfo,
        backingObject,
        undefined /* onProgressHandler */
    );

    return jsonResponse;
}
